documentReady(function($, Lum){
    $('.js-form-caluse-register').on('click', function(e) {
        e.preventDefault();
        var $thisButton = $(this);
        $("#form-clause-registry").parsley().whenValidate().done(function() {
            $thisButton.addClass('btn-disabled');
            Lum.Recaptcha.onValidation(function(token) { 
                var data = $("#form-clause-registry").serializeArray();
                data.push({name: "action", value: 'clause_registry'});
                data.push({name: "re_token", value: token});
                $.post(script_options.ajax_url, $.param(data), function(response) {
                    console.log(response);
                    if (!response.valid) {
                        alertErrors(response.errors);
                        return;
                    }
                    console.log(response.ID);
                    Lum.Cookie.set('clause_register_id', response.ID, 3600 * 1000 * 24 * 365 * 10);
                    
                    Lum.Recaptcha.reset();
                    document.location.href = '/clause-search/',true;
                    // window.location.href = '/clause-search/'
                }).fail(function() {
                }).done(function() {
                    $thisButton.removeClass('btn-disabled');
                });
            });
        });
    })
});